export const enum Layouts {
  LOGIN_LAYOUT = 'login-layout',
  MAIN_LAYOUT = 'main-layout',
  INFO_LAYOUT = 'info-layout'
}
